import React from "react";
import { Table, Input, Button, Space, Divider , Modal } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";


const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
  },
  {
    key: "2",
    name: "Joe Black",
    age: 42,
    address: "London No. 1 Lake Park",
  },
  {
    key: "3",
    name: "Jim Green",
    age: 32,
    address: "Sidney No. 1 Lake Park",
  },
  {
    key: "4",
    name: "Jim Red",
    age: 32,
    address: "London No. 2 Lake Park",
  },
];

class Native_Users_Table extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            حذف
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleChangeClick = (record , index) => {
    // console.log(record , index , "is clicked fact");
    Modal.confirm({
      title: 'تغییر اطلاعات نیروگاه',
      content: (
        <div>
          آیا از تغییر اطلاعات کاربر {record.name} اطمینان دارید ؟
        </div>
      ),
      okText:"تایید",
      okType:"danger",
      cancelText:"بازگشت",
      onCancel(){},
      onOk() {}
    });
  }
  handleDeleteClick = (record , index) => {
    // console.log(record , index , "is deleted fact");
    Modal.confirm({
      title: 'حذف نیروگاه',
      content: (
        <div>
          آیا از حذف کاربر {record.name} اطمینان دارید ؟
        </div>
      ),
      okText:"حذف",
      okType:"danger",
      cancelText:"بازگشت",
      onCancel(){},
      onOk() {}
    });
  }

  render() {
    const columns = [
      {
        title: "نام کاربر",
        dataIndex: "name",
        key: "name",
        
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "نام کاربری",
        dataIndex: "age",
        key: "age",
       
        ...this.getColumnSearchProps("age"),
      },
      {
        title: "وضعیت",
        dataIndex: "address",
        key: "address",
        ...this.getColumnSearchProps("address"),
      },
      {
        title: "سطح دسترسي",
        dataIndex: "address",
        key: "address",
        ...this.getColumnSearchProps("address"),
      },
      {
        title: "عملیات",
        key: "actions",
        render: (text , record , index) => {
          return (
            <Space>
              <Button type="link" onClick={()=>this.handleChangeClick(record , index)}>تغییر</Button>
              <Divider type="vertical" />
              <Button type="link"  onClick={()=>this.handleDeleteClick(record , index)}>حذف</Button>
            </Space>
          );
        },
      },
    ];
    return <Table columns={columns} dataSource={data} pagination={{pageSize:10 }}/>;
  }
}
export default Native_Users_Table;
